import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  iconfont: 'md',
})

export default new Vuetify({
  // Mantém 'md' (Material Icons) para não quebrar ligaduras existentes;
  // ícones mdi-* continuam funcionando pois o @mdi/font está carregado.
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#038b8b',   // teal da marca
        secondary: '#0f0f41', // azul-marinho
        accent: '#2B3674',    // indigo
        info: '#2B3674',
        success: '#2e9b5b',
        warning: '#f59e0b',
        error: '#e53935',
        background: '#f4f6fb',
      },
    },
  },
});
